import Backdrop from '@material-ui/core/Backdrop'
import styled from 'styled-components'

export const ModalOuter = styled.div<{
  contentType: string
}>`
  background: ${p => p.theme.webMktPalette.background.white};
  border-radius: 2px;
  margin: 0 auto;
  position: absolute;
  top: ${p => (p.contentType === 'speakerText' ? 0 : 50)}%;
  left: 50%;
  transform: ${p =>
    p.contentType === 'speakerText' ? 'translateX(-50%)' : 'translateX(-50%) translateY(-50%)'};
  padding: 22px 40px 40px 40px;
  width: 100%;
  max-width: 840px;
  box-sizing: border-box;
  margin-top: ${p => (p.contentType === 'speakerText' ? '320px' : 'auto')};

  &.MyCompanyBody__Add-User-Modal {
    width: 100%;
    max-width: 840px;
    padding: 24px 40px 24px 24px;
    max-height: 85vh;
    overflow: scroll;
    .Modal-Close-Icon {
      margin-right: 10px;
    }
  }
  .Modal-Title-Container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    img: {
      margin: 16px 24px 16px 24px;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-align-items: flex-start;
      -webkit-box-align: flex-start;
      -ms-flex-align: flex-start;
      align-items: flex-start;
    }
  }
  .Modal-Close-Icon {
    min-width: 10px;
    cursor: pointer;
    &:hover {
      cursor: pointer;
    }
  }
  .Modal-Title {
    color: ${p => p.theme.webMktPalette.grayCold[60]};
    font-size: 32px;
    line-height: 38px;
  }
  .Modal-Fields-Container {
    width: 100%;
    margin-top: 24px;
  }
  &.ReviewModal {
    padding: 8px 0 32px 0;
    max-width: 634px;
    .Modal-Title-Container,
    .ReviewsModal__Subtitle,
    .ReviewModal__Submit {
      padding: 0 8px 0 56px;
    }
    .Modal-Title-Container {
      align-items: flex-start;
    }
    .Modal-Title {
      font-weight: 900;
      font-size: 2.8rem;
      line-height: 3.6rem;
      color: ${p => p.theme.webMktPalette.text.primaryBlack};
      margin-top: 24px;
    }
    .Modal-Fields-Container {
      margin-top: 8px;
    }
    .ReviewsModal__Subtitle {
      margin-right: 46px;
      line-height: 2.4rem;
      color: #333c4b;
    }
    .ReviewModal__Reviews {
      padding: 16px 56px;
      margin: 32px 0;
      background: ${p => p.theme.webMktPalette.background.gray};
    }
  }
  &.AddCustomLicenseNameModal {
    max-width: 588px;
  }
  &.LeadershipBioModal {
    padding: 32px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    .Modal-Title-Container {
      align-items: start;
    }

    ${props => props.theme.breakpoints.down('xs')} {
      max-width: ${p =>
        p.contentType === 'speakerText' ? 'calc(100% - 36px)' : 'calc(100% - 16px)'};
      max-height: calc(100% - 16px);
      overflow: scroll;
      padding: 24px;
      margin-top: ${p => (p.contentType === 'speakerText' ? '64px' : 'auto')};

      .Modal-Title-Container {
        max-height: 32px;
        align-items: start;
      }
    }
  }
`

export const CustomBackdrop = styled(Backdrop)`
  background-color: ${p => p.theme.webMktPalette.background.black} !important;
  opacity: 0.9 !important;
`

export const CustomBackdropDotted = styled(Backdrop)`
  background-color: ${p => p.theme.webMktPalette.background.black} !important;
  opacity: 0.9 !important;
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    background-size: 24px 24px;
    background-image: radial-gradient(white 1px, transparent 0);
  }
`
